import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateNotificationsApi } from '../../../redux/Reducers/commonApis';
import { toast } from 'react-hot-toast';
import Loader from '../../../components/Loader';
import { getProfileDataApi } from '../../../redux/Reducers/ProfileReducer';

export default function MemberNotifications({ accountType }) {
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const [notificationData, setNotificationData] = useState({
    email: [
      {
        name: 'New Orders',
        data: [
          {
            id: 'new_order_email',
            type: 'New Orders',
            active: profileData?.new_order_email_notification || false,
          },
        ],
      },
      {
        name: 'Pickup Reminder',
        data: [
          {
            id: 'pickup_reminder_email',
            type: 'Pickup Reminder',
            active: profileData?.pickup_reminder_email_notification || false,
          },
        ],
      },
      {
        name: 'Delivered Orders',
        data: [
          {
            id: 'delivered_orders_email',
            type: 'Delivered Orders',
            active: profileData?.delivered_orders_email_notification || false,
          },
        ],
      },
      {
        name: 'Promotions & Marketing',
        data: [
          {
            id: 'promotions_email_opt_in',
            type: 'Promotions & Marketing',
            active: profileData?.promotions_email_opt_in || false,
          },
        ],
      },
    ],
    text: [
      {
        name: 'Promotions & Marketing',
        data: [
          {
            id: 'marketing_sms_opt_in',
            type: 'Promotions & Marketing',
            active: profileData?.marketing_sms_opt_in || false,
          },
        ],
      },
    ],
  });

  return (
    <>
      <div className=''>
        <div className='z-0 rounded-lg bg-white sm:mb-6'>
          <header className='flex items-center border-b border-gray-100 p-6'>
            <h5 className='go-textnormal-18 my-1 flex-1'>Email Notifications</h5>
          </header>
          {accountType == 'ORGANIZATION_MEMBER' && (
            <p className='px-6 pt-6 text-sm text-gray-500'>
              To make changes to your notification settings please contact the administrator of your account.
            </p>
          )}
          <div className='border-b border-gray-100 p-6'>
            <table className='w-full table-auto'>
              <tbody>
                {notificationData?.email?.map((item, index) => (
                  <tr key={index}>
                    <td className='go-textblack-15 py-2'>{item.name}</td>
                    {item?.data?.map((elm, idx) => (
                      <td className='go-textblack-15 table-cell justify-items-center py-2 text-center ' key={idx}>
                        {elm.active ? 'Yes' : 'No'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <div className=''>
        <div className='z-0 rounded-lg bg-white '>
          <header className=' items-center border-b border-gray-100 p-6'>
            <h5 className='go-textnormal-18 my-1 flex-1'>Text Notifications</h5>
          </header>
          {accountType == 'ORGANIZATION_MEMBER' && (
            <p className='px-6 pt-6 text-sm text-gray-500'>
              To make changes to your notification settings please contact the administrator of your account.
            </p>
          )}
          <div className='border-b border-gray-100 p-6'>
            <table className='w-full table-auto'>
              <tbody>
                {notificationData?.text?.map((item, index) => (
                  <tr key={index}>
                    <td className='go-textblack-15 py-2'>{item.name}</td>
                    {item?.data?.map((elm, idx) => (
                      <td className='go-textblack-15 table-cell justify-items-center py-2 text-center ' key={idx}>
                        {elm.active ? 'Yes' : 'No'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
    </>
  );
}
